<template>
  <div class="page-index">
    <HomeLanding :settings="settings" :landing-video="landingVideo" />
    <HomeSections :sections="sections" />
  </div>
</template>

<script>
import HomeLanding from '~/components/home/HomeLanding'
import HomeSections from '~/components/home/HomeSections'

export default {
  components: {
    HomeLanding,
    HomeSections,
  },
  props: {
    landingVideo: {
      type: String,
      default: '',
    },
    settings: {
      type: Object,
    },
    sections: {
      type: Array,
    },
  },
}
</script>

<style lang="scss">
.page-index {
  /* padding-top: var(--header-height); */
}
</style>